import * as React from 'react';
import * as styles from './counter.css';

export interface ICounterProps {
  currentSlide: number;
  totalSlides: number;
}

export const Counter = (props: ICounterProps) => {
  const { currentSlide, totalSlides } = props;

  return (
    <div className={styles['counter']}>
      <div className={styles['icon']}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 5.49989C15 4.39532 14.1046 3.5 13 3.5H11.2772L10.2715 1.322C10.223 1.22523 10.1485 1.14386 10.0564 1.08699C9.96435 1.03012 9.85824 1 9.75 1H6.25C6.14176 1 6.03565 1.03012 5.94355 1.08699C5.85145 1.14386 5.77699 1.22523 5.7285 1.322L4.72283 3.5H3C1.89543 3.5 1 4.39532 1 5.49989C1 7.97728 1 10.5227 1 13.0001C1 14.1047 1.89543 15 3 15H13C14.1046 15 15 14.1047 15 13.0001C15 10.5227 15 7.97728 15 5.49989ZM8 12.0833C7.42314 12.0833 6.85923 11.9123 6.37959 11.5918C5.89994 11.2713 5.52611 10.8158 5.30535 10.2828C5.0846 9.74988 5.02684 9.16343 5.13938 8.59765C5.25192 8.03188 5.5297 7.51218 5.9376 7.10427C6.34551 6.69637 6.86521 6.41858 7.43099 6.30604C7.99676 6.1935 8.58321 6.25126 9.11616 6.47202C9.64911 6.69277 10.1046 7.06661 10.4251 7.54625C10.7456 8.0259 10.9167 8.5898 10.9167 9.16667C10.9167 9.94021 10.6094 10.6821 10.0624 11.2291C9.51541 11.776 8.77355 12.0833 8 12.0833Z"
            fill="white"
          />
        </svg>
      </div>
      <span className={styles['text']}>
        {currentSlide}/{totalSlides}
      </span>
    </div>
  );
};
